import { downloadFileUsingBinString } from '@evidentid/file-utils/blobs';
import { CustomProperty } from '@evidentid/tprm-portal-lib/models/dashboard';
import { buildCsv } from '@evidentid/universal-framework/csv';

import { generateSampleCsvData } from '@/modules/entity-management/utils/csv-sample/utils/generateSampleCsvData';

export function downloadSampleCsv(
    customProperties: CustomProperty[],
    requirementTypes?: string[],
    contactEmailUniquenessEnabled = true,
) {
    const csv = generateSampleCsvData(customProperties, requirementTypes, contactEmailUniquenessEnabled);
    downloadFileUsingBinString(buildCsv(csv), 'Import Entity Sample.csv');
}
